<app-product
  *ngIf="!(discountService.activeDiscountCampaign$ | async)"
  [alias]="product.alias"
  [photo]="product.menuPhoto"
  [caption]="product.caption"
  [summary]="product.summary"
  [notice]="product.notice"
  [price]="$any(product.prices[0]?.[1])"
  (buttonClick)="onButtonClick()"
></app-product>
<app-product
  *ngIf="discountService.activeDiscountCampaign$ | async as discountCampaign"
  [alias]="product.alias"
  [photo]="product.menuPhoto"
  [caption]="product.caption"
  [summary]="product.summary"
  [notice]="product.notice"
  [price]="$any(product.prices[0]?.[1])"
  [discount]="getDiscount(discountCampaign, $any(product))"
  (buttonClick)="onButtonClick()"
></app-product>
